import classNames from 'classnames';
import React from 'react';
import { RobotWithCloudIcon } from '../Icons';
import styles from './AuthenticationError.module.scss';
import { SimpleAppBar } from './SimpleAppBar';
import { getUserManager } from '../../Config/ApplicationConfig';

export class AuthenticationError extends React.Component {

    public render() {
        return (
            <div id='main'>
                <div className={styles.container}>
                    <SimpleAppBar />
                    <div className={styles.containerBody}>
                        <RobotWithCloudIcon />
                        <h1 className={styles.logoutHeading}>Authentication Error occurred</h1>
                        <h3 className={styles.logoutSubheading}>Please try logging out or opening the application in a <a className={styles.newTabLink}
                            href='.' target='_blank'>new tab</a></h3>
                        <p>If this error continues, please contact your administrator</p>
                        <p>
                            <button onClick={this.handleSignout} className={classNames(styles.button, styles.link, styles.default)}>
                                Logout of application
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    private handleSignout = () => {
        getUserManager().signoutRedirect();
    };
}
